import axios from "axios"

const url = "/distributor/admin/api/v1/inventory/packages"
export function getAllDealerPackagesListing (parameters) {
  return new Promise((resolve, reject) => {
    axios.post(url, {
      length: parameters.length,
      start: parameters.start,
      order: parameters.order,
      order_by: parameters.order_by,
      dealer: parameters.dealer,
      filter: {
        status: parameters.filter.status,
        search: parameters.filter.search,
        search_by: parameters.filter.search_by,
        pattern: parameters.filter.pattern,
        created_at: parameters.filter.created_at,
        located_at: parameters.filter.located_at,
        products: parameters.filter?.products || []
      }
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};